import React__default from 'react';
import classnames from 'classnames';
import styles from './Button.module.css.js';

function Button({ children, danger, disabled, element, external, fullWidth, id, loading, outlined, role, size, submit, url, onClick, }) {
    const className = classnames(styles.Button, {
        [styles.Button__danger]: danger,
        [styles.Button__disabled]: disabled,
        [styles.Button__isLoading]: loading,
        [styles.Button__outlined]: outlined,
        [styles[`Button__${size}`]]: size,
        [styles.Button__fullWidth]: fullWidth,
    });
    const attributes = {
        id,
        disabled: disabled || loading,
        target: external ? "_blank" : null,
        href: url,
        onClick: () => handleClick(),
        className,
    };
    const loadingIcon = (React__default.createElement("svg", { className: styles.Button_Spinner, viewBox: "0 0 50 50" },
        React__default.createElement("circle", { className: styles.Button_SpinnerPath, cx: "25", cy: "25", r: "20", fill: "none", strokeWidth: "5" })));
    const handleClick = () => {
        // Handles click for logic and executes the passing callback
        if (onClick)
            onClick();
        return null;
    };
    if (element !== "div") {
        return (React__default.createElement("button", { type: submit ? "submit" : "button", ...attributes }, loading ? loadingIcon : children));
    }
    else {
        return (React__default.createElement("div", { role: role, ...attributes }, loading ? loadingIcon : children));
    }
}

export { Button };
//# sourceMappingURL=Button.js.map
